import { withRouter } from 'react-router'
import SinglePage from '../components/SinglePage'
import { connect } from 'react-redux'
import { compose, graphql } from 'react-apollo';
import { getSinglePageBySlug } from "../graphqlDic";

export default compose(
    graphql(getSinglePageBySlug,{
        name:'getSinglePage',
        options: (ownProps) => ({
            variables: {
                slug: ownProps.match.params.slug
            }
        })
    })
)(withRouter(
    connect(
        null,
        null
    )(SinglePage)
));



// WEBPACK FOOTER //
// ./src/containers/GetSinglePage.js